import React from 'react';
import PropTypes from 'prop-types';
import { Select, List } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import GroupedRates from './groupedRates';
import UngroupedRates from './ungroupedRates';

/**
 * Return a Select button to choose if we wants to include all rates or not (only if we have an event), and if not, display components to
 * check rates, groups , ...
 *
 * @param event : int => event ID of chosen event
 * @param onSelectException : func => Action to perform on choose Mode
 * @param mode : string => Mode of select Rate (All or Select)
 * @param ratesAndGroups : array => array containing rates and groups with rates inside
 * {
 *      "rates" : [{ id: RateIdWithouGroup, name:"Rates Name without group"}, {...}],
 *      "groups": [{
 *          id: GroupId,
 *          name: "Group Name",
 *          rates:[{ id: RateIdContainingGroup, name:"Rates Name Containing Group"}, {...}]
 *      }]
 * }
 * @param ratesChecked : array => rates ID checked
 * @param onRateChecked : func => Action to perform when we check / uncheck a rate
 * @param onGroupChecked : func => Action to perform when we check / uncheck a group of rate
 * @param groups : array => ID group of rate checked
 *
 * @param {*} param0
 */
export default function RateSelector({ event, onSelectException, mode, ratesAndGroups, ratesChecked, onRateChecked, onGroupChecked, groups }) {
    const { t } = useTranslation();
    const exceptionChoice = [
        { key: 'all', value: 'All', text: t('ticket.resales.config.mode_selector_all') },
        { key: 'select', value: 'Select', text: t('ticket.resales.config.mode_selector_select') }
    ];

    if (!event) {
        return null;
    }

    const listOfRates = () => {
        if (mode !== 'All' && ratesAndGroups) {
            return (
                <div>
                    <List>
                        <div className="rate-block-rules-edit">
                            <UngroupedRates rates={ratesAndGroups.rates} ratesChecked={ratesChecked} onRateChecked={onRateChecked} />
                            <GroupedRates
                                groups={ratesAndGroups.groups}
                                groupsChecked={groups}
                                onGroupChecked={onGroupChecked}
                                ratesChecked={ratesChecked}
                                onRateChecked={onRateChecked}
                            />
                        </div>
                    </List>
                </div>
            );
        }
    };

    return (
        <div>
            <Select
                search
                fluid
                className={'event-selector-select-button'}
                value={mode}
                options={exceptionChoice}
                onChange={(e, { value }) => {
                    onSelectException(value);
                }}
            />
            {listOfRates()}
        </div>
    );
}

RateSelector.propTypes = {
    event: PropTypes.number,
    onSelectException: PropTypes.func.isRequired,
    mode: PropTypes.string.isRequired,
    ratesAndGroups: PropTypes.object.isRequired,
    ratesChecked: PropTypes.array.isRequired,
    onRateChecked: PropTypes.func.isRequired,
    onGroupChecked: PropTypes.func.isRequired,
    groups: PropTypes.array.isRequired
};
